<template>
  <div class="mini-cal" @click.stop>
    <div class="mini-cal-header">
      <button type="button" class="mini-nav" @click="mesAnterior">‹</button>
      <span class="mini-mes">{{ mesNombre }}</span>
      <button type="button" class="mini-nav" @click="mesSiguiente">›</button>
    </div>

    <div class="mini-semana">
      <span v-for="(d, i) in ['Lu','Ma','Mi','Ju','Vi','Sá','Do']" :key="i">{{ d }}</span>
    </div>

    <div class="mini-grilla">
      <button
        v-for="(dia, i) in dias"
        :key="i"
        type="button"
        class="mini-dia"
        :class="{ 'otro-mes': !dia.esDelMes, hoy: dia.esHoy, sel: dia.esSeleccionado }"
        @click="elegir(dia)"
      >
        {{ dia.numero }}
      </button>
    </div>

    <div class="mini-footer">
      <button type="button" class="mini-hoy" @click="irHoy">Hoy</button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  modelValue: { type: Date, default: () => new Date() },
});
const emit = defineEmits(['seleccionar']);

const mesVista = ref(new Date(props.modelValue.getFullYear(), props.modelValue.getMonth(), 1));

const mesNombre = computed(() => {
  const t = mesVista.value.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
  return t.charAt(0).toUpperCase() + t.slice(1);
});

function mismaFecha(a, b) {
  return a.getFullYear() === b.getFullYear() &&
         a.getMonth() === b.getMonth() &&
         a.getDate() === b.getDate();
}

const dias = computed(() => {
  const primero = new Date(mesVista.value.getFullYear(), mesVista.value.getMonth(), 1);
  const diaSemana = primero.getDay();            // 0 = domingo
  const offset = diaSemana === 0 ? 6 : diaSemana - 1; // grilla empieza en lunes
  const inicio = new Date(primero);
  inicio.setDate(primero.getDate() - offset);

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const sel = props.modelValue;

  const arr = [];
  const cursor = new Date(inicio);
  for (let i = 0; i < 42; i++) {
    arr.push({
      numero: cursor.getDate(),
      fecha: new Date(cursor),
      esDelMes: cursor.getMonth() === mesVista.value.getMonth(),
      esHoy: mismaFecha(cursor, hoy),
      esSeleccionado: mismaFecha(cursor, sel),
    });
    cursor.setDate(cursor.getDate() + 1);
  }
  return arr;
});

function mesAnterior() {
  mesVista.value = new Date(mesVista.value.getFullYear(), mesVista.value.getMonth() - 1, 1);
}
function mesSiguiente() {
  mesVista.value = new Date(mesVista.value.getFullYear(), mesVista.value.getMonth() + 1, 1);
}
function elegir(dia) {
  emit('seleccionar', dia.fecha);
}
function irHoy() {
  const h = new Date();
  emit('seleccionar', new Date(h.getFullYear(), h.getMonth(), h.getDate()));
}
</script>

<style scoped>
.mini-cal {
  width: 280px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  padding: 12px;
  font-family: system-ui, sans-serif;
  user-select: none;
}

.mini-cal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.mini-mes {
  font-weight: 700;
  color: #333;
  font-size: 14px;
  text-transform: capitalize;
}
.mini-nav {
  background: #eaf1ff;
  border: none;
  color: #678AB2;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  transition: background 0.15s;
}
.mini-nav:hover { background: #dbeafe; }

.mini-semana {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 4px;
}
.mini-semana span {
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #9aa5b1;
  padding: 4px 0;
}

.mini-grilla {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}
.mini-dia {
  border: none;
  background: none;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.mini-dia:hover { background: #f0f4f8; }
.mini-dia.otro-mes { color: #c8cdd3; }
.mini-dia.hoy {
  color: #678AB2;
  font-weight: 700;
  box-shadow: inset 0 0 0 1px #678AB2;
}
.mini-dia.sel {
  background: #678AB2;
  color: #fff;
  font-weight: 700;
}
.mini-dia.sel:hover { background: #4d6f96; }

.mini-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.mini-hoy {
  background: #eaf1ff;
  color: #678AB2;
  border: none;
  border-radius: 8px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.mini-hoy:hover { background: #dbeafe; }
</style>
